import type { ItineraryDay } from "@/lib/types";
import { findTextEvent, type TextEvent } from "../calendar/tripTextEvents";

/**
 * The event the trip description names but nobody has confirmed — the same one
 * the calendar strip proposes, derived by the same rule, so the strip and the
 * day it points at can never disagree: only when the itinerary holds no
 * event/activity yet, and only from the outbound/return flight window.
 */
export function pendingEventFor(
  days: ItineraryDay[],
  description: string | null | undefined,
  flightDates: string[],
): TextEvent | null {
  if (!description) return null;
  const hasEvent = days.some((d) =>
    d.segments.some(
      (s) => s.kind === "item" && (s.item_type === "event" || s.item_type === "activity"),
    ),
  );
  if (hasEvent) return null;
  return findTextEvent(description, flightDates);
}
